export default __webpack_public_path__ + "static/media/telegram.bf82a9cf.svg";